import { useEffect, useState,useRef } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Table, Tooltip } from "antd";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import StatusTag from "../../../components/StatusTag";

const FreeRegistrationList = () => {
  const calledOnce = useRef(false);
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const FREE_REGISTRATION_LIST = () => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.free_registration_list, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.data);
        } else {
          set_page_loader(false);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
      set_page_loader(false);
    }
  };

  const CHANGE_COMPANY_STATUS_API = (company_id) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("company_id", company_id);
      post(ApiURL.change_company_status, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Success", res?.message);
          FREE_REGISTRATION_LIST();
        } else {
          ErrorToast("Error", res?.message);
        }
      });
    } catch (error) {
      console.error("Error changing company status:", error);
    } finally {
    }
  };


  useEffect(() => {
    if (!calledOnce.current) {
      FREE_REGISTRATION_LIST();
      calledOnce.current = true;
    }
  }, []);

  const columns = [
    {
      title: "Company Name",
      dataIndex: "company_name",
      align: "center",
      key: "company_name",
    },
    {
      title: "Email",
      dataIndex: "company_email",
      align: "center",
      key: "company_email",
    },
  
    {
      title: "Country",
      dataIndex: "country",
      align: "center",
      key: "country",
    },
   
    {
      title: "Demo Status",
      dataIndex: "all_status",
      align: "center",
      key: "all_status",
      render: (all_status) => (
        <StatusTag status={all_status ? all_status : ""} />
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => new Date(record?.created_at).toLocaleString(),
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => new Date(record?.updated_at).toLocaleString(),
    },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (text, record) => (
        <Popconfirm
          title="Change Status"
          description={`Has the demo for "${record.company_name}" been completed?`}
          onConfirm={() => CHANGE_COMPANY_STATUS_API(record.id)}
          okText="Yes"
          cancelText="No"
        >
          <Tooltip title="Change Status">
            <Button
              type="primary"
              size="small"
              icon={<CheckCircleOutlined />}
            />
          </Tooltip>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <div>
        <div className="row" style={{ padding: "10px" }}>
          <div
            className="col-3"
            style={{ marginLeft: "5px", alignSelf: "end" }}
          >
            <div className="theme-content-title text-left">
              <h3>Free Registration List</h3>
            </div>
          </div>
          <div className="col-3"></div>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={page_loader}
          className="custom-table"
        />
      </div>
    </>
  );
};

export default FreeRegistrationList;
